import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { IOpenCartAPIResponseData , IOpenCartAPIResponse } from "@/api_framework/api_modals/DayClosing";

AxiosCurlirize(axios, () => {});

export const useDayClosingOpenCartAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [openCartData, setOpenCartData] = useState<IOpenCartAPIResponseData[]>([]);

  const execute = useCallback(
    async (clinic_id: string, shift: string) => {
      dispatch(
        setLoading({
          key: "isClosingDataInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(DAY_CLOSING_APIS.OPEN_CART.baseURL ?? "", {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
            params: {
              clinic_ids: clinic_id,
              shift,
            },
          })
          .then((res: AxiosResponse<IOpenCartAPIResponse>) => {
            if (res.data.status) {
              setOpenCartData(res.data.data ?? []);
              dispatch(
                setLoading({
                  key: "isClosingDataInProgress",
                  status: false,
                }),
              );
              return { status: true };
            } else {
              setOpenCartData([]);
              dispatch(
                setLoading({
                  key: "isClosingDataInProgress",
                  status: false,
                }),
              );
              //
            }
          })
          .catch((e: AxiosError) => {
            setOpenCartData([]);
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            dispatch(
              setLoading({
                key: "isClosingDataInProgress",
                status: false,
              }),
            );
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        setOpenCartData([]);
        captureError(e);
        dispatch(
          setLoading({
            key: "isClosingDataInProgress",
            status: false,
          }),
        );
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, dispatch, sendCurl],
  );
  return { execute, openCartData };
};
